import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useWishlist = create(
  persist(
    (set) => ({
      wishlist: [],
      products: [],
      toggleWishlist: (sku, product) => {
        return set((state) => {
          if (state.wishlist.find((wlSku) => wlSku === sku)) {
            return {
              wishlist: state.wishlist.filter((wlSku) => wlSku !== sku),
              products: state.products
                .filter((info) => info?.sku !== sku)
                ?.filter((info) => !!info),
            };
          }
          return {
            wishlist: [...state.wishlist, sku],
            products: [...state.products.filter((info) => !!info), product],
          };
        });
      },
    }),
    {
      name: 'wishlist',
    }
  )
);

export default useWishlist;
